import React from 'react';
import LottieAnimation from '@/v2/components/behaviours/LottieAnimation';
import Icon from '@/v2/components/atoms/Icon';
import animationData from './LottieDesktopExpand.json';

const DesktopExpand = (props) => (
    <Icon iconName="DesktopExpand" {...props}>
        <LottieAnimation loop autoplay animationData={animationData} />
    </Icon>
);

export default DesktopExpand;
